// PLAN-075: the enums of generic audit criteria sets, the criteria values and the AI outcomes, mirrored by hand
// from the server's REDLAB.ISOPlanner.Contracts.AI.DataModels (the DTOs carry them as numbers).

// Which set an entity's criteria come from: its own set, its subtype's or its family's generic set.
export enum AuditCriteriaLayer {
  None = 0,
  Specific = 1,
  Subtype = 2,
  Family = 3,
}

// The period of the criteria values of a list.
export enum AuditCriteriaPeriodKind {
  Latest = 0,
  AuditYear = 1,
  PreviousAuditYear = 2,
  Custom = 3,
}

// What produced an AI criterion outcome.
export enum AICriterionOutcomeSourceKind {
  ProcessRun = 1,
  AgentTurn = 2,
  Check = 3,
}

// The result an AI criterion outcome proposes.
export enum AICriterionOutcomeResult {
  Pass = 1,
  Fail = 2,
  Inconclusive = 3,
}

// The life of an AI criterion outcome.
export enum AICriterionOutcomeStatus {
  Proposed = 1,
  Applied = 2,
  Accepted = 3,
  Dismissed = 4,
  Superseded = 5,
}

// What answers a criterion ("Answered by").
export enum AuditCriterionAutomationKind {
  Process = 1,
  Skill = 2,
  Check = 3,
}

// Where an answer in the criteria values comes from.
export enum AuditCriterionValueSource {
  Assessment = 1,
  Audit = 2,
  Integration = 3,
}

// The AI status of a criteria value as a code (bits 4-8 of the cell's flags): 1 to 7 the inspection statuses, 8 and
// 9 an automation's outcome, 10 to 14 the not-audited reasons.
export enum AuditCriterionValueAIStatus {
  None = 0,
  Unknown = 1,
  Satisfied = 2,
  PartiallySatisfied = 3,
  NotSatisfied = 4,
  Contradicted = 5,
  NotApplicable = 6,
  NotInspectable = 7,
  Proposed = 8,
  Accepted = 9,
  NotAuditedManual = 10,
  NotAuditedNoEvidence = 11,
  NotAuditedNotInspected = 12,
  NotAuditedEvidenceTaskOpen = 13,
  NotAuditedNoCheckRuns = 14,
  Other = 31,
}

// The compact cell of the criteria values (spec 9.4), mirrored from the server's AuditCriteriaValueCell:
// values[entityId][lineageKey] = [resultNumber, resultDate, taskId, flags].
export type AuditCriteriaValueCell = [number | null, string, number | null, number];

export const auditCriteriaValueCellIndex = {
  resultNumber: 0,
  resultDate: 1,
  taskId: 2,
  flags: 3,
} as const;

export const auditCriteriaValueFlags = {
  hasComment: 1,
  hasEvidence: 2,
  sourceShift: 2,
  sourceMask: 0x3,
  aiStatusShift: 4,
  aiStatusMask: 0x1f,
} as const;
